import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import SkillLevelProp from '../../../../commonComponents/propTypes/skillLevelProp';

export const getTeamName = name => {
  const nameSliced = name.split(' ');
  const firstWord = nameSliced[0].charAt(0).toUpperCase();
  if (nameSliced.length === 1) {
    return firstWord;
  }
  return firstWord + nameSliced[1].charAt(0).toUpperCase();
};

function Rewards({ t, rewards }) {
  const { coins, userLevel, chatGroup, userType } = rewards;
  return (
    <div className="">
      {coins && (
        <div className="coins-section">
          <div className="coins-icon-wrapper">
            <img src="/images/shop/coins.svg" alt="coins" />
          </div>
          <span>{`${coins} ${t('challengeDetails.about.coins')}`}</span>
        </div>
      )}
      {userLevel && (
        <div className="userLevel-section">
          <h6>{t('challenge.upgrade.level')}</h6>
          <div>
            <img src={userLevel.icon} alt="icon" />
            <span>{userLevel.name}</span>
          </div>
        </div>
      )}
      {userType && (
        <div className="userType-section">
          <h6>{t('challenge.upgrade.type')}</h6>
          <div>
            <span>{userType}</span>
          </div>
        </div>
      )}
      {chatGroup && (
        <div className="team-section">
          <h6>{t('challenge.upgrade.chat')}</h6>
          <div className="team">
            <div className="team-img">
              <span>{getTeamName(chatGroup)}</span>
            </div>
            <span className="chat-name">{chatGroup}</span>
          </div>
        </div>
      )}
    </div>
  );
}

Rewards.propTypes = {
  t: PropTypes.func.isRequired,
  rewards: PropTypes.shape({
    coins: PropTypes.string,
    userLevel: PropTypes.shape(SkillLevelProp.propType),
    chatGroup: PropTypes.string,
    userType: PropTypes.string,
  }).isRequired,
};

export default translate(Rewards);
